import React from "react";
import "../App.css";

function About() {
  return (
    <div>
      <h2 className="section-title text-center mb-5">About Me</h2>

      <div className="card-custom">
        <h3 className="text-accent mb-4">Software Engineer | Full Stack Developer</h3>
        <p className="text-main lead mb-4">
          I am <strong className="text-accent">Adarsh Kumar Mishra</strong>, a Computer Science graduate with a strong focus on 
          building scalable web applications and backend systems. With a solid foundation in 
          <strong> Java, Spring Boot, and the MERN Stack</strong>, I enjoy solving complex 
          problems and creating seamless digital experiences.
        </p>

        <div className="row g-4">
          <div className="col-md-6">
            <h5 className="text-accent small text-uppercase fw-bold mb-3">Core Expertise</h5>
            <p className="text-dim small">
              Proficient in building RESTful APIs using **Node.js, Express, and Spring Boot**. 
              Experienced in frontend development with **React.js and Next.js**, and 
              database management using **MongoDB and MySQL**.
            </p>
          </div>
          <div className="col-md-6">
            <h5 className="text-accent small text-uppercase fw-bold mb-3">Cloud & Automation</h5>
            <p className="text-dim small">
              Practical exposure to **AWS (EC2, S3)** and **Docker**. Skilled in 
              web automation using **Playwright** and integrating **AI models (Gemini)** 
              to enhance application intelligence.
            </p>
          </div>
        </div>

        <div className="mt-5 pt-4 border-top border-secondary">
          <h5 className="text-accent small text-uppercase fw-bold mb-3">Education Highlights</h5>
          <div className="d-flex flex-column gap-2 text-dim small">
            <div>🎓 <strong>B.E. Hons (Cloud Computing)</strong> - Chandigarh University (2022-2025)</div>
            <div>📜 <strong>Diploma in CS & Engineering</strong> - T.G.B. Govt. Polytechnic (2019-2022)</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
